const initialState = []

// Action Types
export const SET_SEARCH = 'SET_SEARCH'

// Action Creators
export const setSearch = (payload) => ({
  type: SET_SEARCH,
  payload
})

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH:
      const array = [...state]
      const findIndex = state.findIndex((item) => item.searchType === action.payload.searchType)
      if (findIndex > -1) {
        array.splice(findIndex, 1, action.payload)
      } else {
        array.push(action.payload)
      }
      return array
    default:
      return state
  }
}

export default searchReducer
